import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { Button } from "./Button";
import UserService from "../services/UserService";
import Loading from "./Loader";
import { COOKIE_OPTIONS } from "../constants";
import { withCookies, Cookies } from "react-cookie";
import { instanceOf } from "prop-types";

export class Payment extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            couponCode: '',
            gstNumber: '',
            priceDetails: null,
            loadingPrice: true,
            isCouponApplied: false,
            couponError: '',
            couponSuccess: '',
            discountAmount: 0,
            totalAfterDiscount: 0
        };
    }

    getModuleDetails = () => {
        const moduleId = this.props.selectedModule;
        
        const moduleMap = {
            'MASTER_PYQ_JEE_26': { id: 24, name: 'Master PYQs', price: 1500 },
            'MASTER_PYQ_JEE_27': { id: 29, name: 'Master PYQs', price: 1500 },
            'MASTER_PYQ_NEET_26': { id: 30, name: 'Master PYQs', price: 1200 },
            'MASTER_PYQ_NEET_27': { id: 31, name: 'Master PYQs', price: 1200 },
            'MASTER_PYQ_JEE_28': { id: 32, name: 'Master PYQs', price: 2500 },
            'MASTER_PYQ_NEET_28': { id: 33, name: 'Master PYQs', price: 2000 },
            'AITS_MAIN_ADVANCED': { id: 25, name: 'AITS JEE MAIN + Advanced', price: 3999 },
            'AITS_NEET': { id: 26, name: 'AITS NEET', price: 2999 },
            'AITS_JEE_ADVANCED': { id: 27, name: 'AITS JEE Advanced', price: 1999 },
            'PRACTICE_PYQ_FREE': { id: null, name: 'Practice PYQs', price: 0 }
        };
        return moduleMap[moduleId] || { id: null, name: 'Unknown', price: 0 };
    }

    fetchPriceDetails = () => {
        const module = this.getModuleDetails();
        
        if (module.price === 0) {
            this.setState({ 
                priceDetails: {
                    total_product_amount: 0,
                    gst_amount: 0,
                    total_amount_with_gst: 0
                },
                loadingPrice: false 
            });
            return;
        }
        
         const signupResponse = sessionStorage.getItem('signupResponse');
        const userData = signupResponse ? JSON.parse(signupResponse) : {};
        const user = userData.user || userData;
        const reqData = {
            product_ids: [module.id],
             user: {
                id: user.id,
                name: user.name,
                email: user.email,
                mobile: user.phone || user.mobile
            },
        };
        
        UserService.getPriceDetails(reqData)
            .then((response) => {
                this.setState({ 
                    priceDetails: response,
                    loadingPrice: false 
                });
            })
            .catch((err) => {
                console.error('Error fetching price details:', err);
                // Fallback to local calculation
                const basePrice = module.price;
                const gst = Math.round(basePrice * 0.18);
                const total = basePrice + gst;
                this.setState({ 
                    priceDetails: {
                        total_product_amount: basePrice,
                        gst_amount: gst,
                        total_amount_with_gst: total
                    },
                    loadingPrice: false 
                });
            });
    }
    
    calculateTotal = () => {
        if (this.state.priceDetails) {
            const basePrice = this.state.priceDetails.total_product_amount;
            let gst = this.state.priceDetails.gst_amount;
            let total = this.state.priceDetails.total_amount_with_gst;
            
            // Use updated GST and total from coupon API response
            if (this.state.isCouponApplied) {
                gst = this.state.gst_amount || gst;
                total = this.state.total_amount_with_gst || total;
            }
            
            return { basePrice, gst, total };
        }
        
        const module = this.getModuleDetails();
        const basePrice = module.price;
        let gst = Math.round(basePrice * 0.18);
        let total = basePrice + gst;
        
        // Use updated GST and total from coupon API response
        if (this.state.isCouponApplied) {
            gst = this.state.gst_amount || gst;
            total = this.state.total_amount_with_gst || total;
        }
        
        return { basePrice, gst, total };
    }

    verifyCouponCode = () => {
        // Ensure token is available before making API call
        const signupResponse = sessionStorage.getItem('signupResponse');
        if (signupResponse) {
            const userData = JSON.parse(signupResponse);
            if (userData.token) {
                localStorage.setItem('userToken', JSON.stringify(userData.token));
            }
        }
        
        const module = this.getModuleDetails();
        const userData2 = signupResponse ? JSON.parse(signupResponse) : {};
        const user = userData2.user || userData2;
        
        const reqData = {
            coupon: this.state.couponCode,
            product_ids: [module.id],
            isOnlineUser: true,
            user: {
                id: user.id,
                name: user.name,
                email: user.email,
                mobile: user.phone || user.mobile,
                active: true
            }
        };
        
        this.setState({ isLoading: true, couponError: '', couponSuccess: '' });
        
        UserService.verifyCoupon(reqData)
            .then((response) => {
                // After verification, apply the coupon
                return UserService.applyCoupon(reqData);
            })
            .then((response) => {
                const maxAmtMsg = response.discount > response.coupon.coupon_amount ? `(Max. Amt. ₹${response.discount})` : '';
                this.setState({ 
                    isLoading: false,
                    isCouponApplied: true,
                    couponSuccess: `Congrats! You got a ${response.coupon?.discount_percentage || 0}% discount. ${maxAmtMsg}`,
                    discountAmount: response.discount || 0,
                    totalAfterDiscount: response.total_amount_after_discount || 0,
                    total_amount_with_gst: response.total_amount_with_gst || this.state.priceDetails?.total_amount_with_gst,
                    gst_amount: response.gst_amount || this.state.priceDetails?.gst_amount
                });
            })
            .catch((err) => {
                this.setState({ 
                    isLoading: false,
                    couponError: err.message || 'Invalid coupon code',
                    isCouponApplied: false
                });
            });
    }
    
    removeCoupon = () => {
        this.setState({
            couponCode: '',
            isCouponApplied: false,
            couponError: '',
            couponSuccess: '',
            discountAmount: 0,
            totalAfterDiscount: 0
        })
    }

    createPackageOrder = (reqData) => {
        console.log('Creating package order with data:', reqData);
        return UserService.createPackageOrder(reqData);
    }

    componentDidMount() {
        // Ensure user token is available for API authentication
        const signupResponse = sessionStorage.getItem('signupResponse');
        if (signupResponse) {
            const userData = JSON.parse(signupResponse);
            if (userData.token && !localStorage.getItem('userToken')) {
                localStorage.setItem('userToken', JSON.stringify(userData.token));
            }
        }
        
        // Check for payment success/failure in URL
        this.checkPaymentStatus();
        
        // Fetch price details from API
        this.fetchPriceDetails();
        
        // Also check on window focus (when user returns from payment gateway)
        window.addEventListener('focus', this.checkPaymentStatus);
    }
    
    componentWillUnmount() {
        window.removeEventListener('focus', this.checkPaymentStatus);
    }
    
    checkPaymentStatus = () => {
        const currentUrl = window.location.href;
        const urlParams = new URLSearchParams(window.location.search);
        const status = urlParams.get('status');
        const paymentInProgress = localStorage.getItem('paymentInProgress');
        
        console.log('=== PAYMENT STATUS CHECK ===');
        console.log('Current URL:', currentUrl);
        console.log('URL Status param:', status);
        console.log('Payment in progress:', paymentInProgress);
        console.log('===========================');
        
        // Check if URL contains success status and payment was in progress
        if (status === 'success' && paymentInProgress === 'true') {
            localStorage.removeItem('paymentInProgress');
            this.handlePaymentSuccess('success');
        } else if (status === 'failure' && paymentInProgress === 'true') {
            localStorage.removeItem('paymentInProgress');
            this.handlePaymentFailure();
        }
    }

    handlePaymentSuccess = (paymentId) => {
        console.log('Payment successful:', paymentId);
        
        // Clear URL params first
        window.history.replaceState({}, document.title, window.location.pathname);
        
        // Store user token and set cookies for auto-login
        const signupResponse = sessionStorage.getItem('signupResponse');
        console.log('=== PAYMENT SUCCESS DEBUG ===');
        console.log('signupResponse:', signupResponse);
        
        if (signupResponse) {
            const response = JSON.parse(signupResponse);
            console.log('Parsed response:', response);
            
            // Store tokens
            localStorage.setItem('userToken', JSON.stringify(response.token));
            localStorage.setItem('user', JSON.stringify(response.user));
            
            // Set cookies for cross-domain authentication
            const paymentOrderId = response.user?.payment_order_id || null;
            this.handleCookie(JSON.stringify(response.token), paymentOrderId ? JSON.stringify(paymentOrderId) : null);
            
            console.log('Tokens and cookies set successfully');
            
            // Clean up storage
            sessionStorage.removeItem('signUpFormData');
            sessionStorage.removeItem('signupResponse');
            sessionStorage.removeItem('selectedModule');
            localStorage.removeItem('signupResponse');
            
            // Show success notification and redirect
            alert('🎉 PAYMENT SUCCESSFUL! \n\nYour payment has been processed successfully. You will now be redirected to the online platform.');
            
            // Redirect to online platform
            console.log('Redirecting to:', process.env.REACT_APP_REDIRECT_LOGIN_URL);
            window.location.href = process.env.REACT_APP_REDIRECT_LOGIN_URL
              + 'auth/login?token=' + encodeURIComponent(response.token)
              + '&keepMeLoggedIn=false';
        } else {
            console.error('No signup response found in sessionStorage');
            alert('Payment successful but unable to auto-login. Please login manually.');
        }
    }

    handlePaymentFailure = () => {
        console.log('Payment failed');
        // Clear URL params
        window.history.replaceState({}, document.title, window.location.pathname);
        alert('Payment failed. Please try again.');
    }

    submitPaymentForm = (order) => {
        const signupResponse = sessionStorage.getItem('signupResponse');
        const userData = signupResponse ? JSON.parse(signupResponse) : {};
        
        console.log('=== FULL ORDER RESPONSE DEBUG ===');
        console.log('Complete order object:', order);
        console.log('order.products:', order.products);
        console.log('order.products[0]:', order.products?.[0]);
        console.log('================================');
        
        // Handle both direct user data and nested user object
        const user = userData.user || userData;
        
        console.log('=== USER DATA DEBUG ===');
        console.log('Raw signupResponse:', signupResponse);
        console.log('Parsed userData:', userData);
        console.log('Final user object:', user);
        console.log('user.name:', user.name);
        console.log('user.email:', user.email);
        console.log('user.phone:', user.phone);
        console.log('=====================');
        
        // Use productsForPurchase (product ID) as productinfo to match backend hash
        const productInfo = order.productsForPurchase || order.products?.[0]?.id || '25';
        
        const params = {
            key: order.key,
            txnid: order.tx_id,
            amount: order.amount,
            productinfo: productInfo,
            firstname: user.name,
            email: user.email,
            phone: user.phone || user.mobile || '9999999999',
            surl: order.surl,
            furl: order.furl,
            hash: order.hash,
            udf1: order.udf1,
            udf2: order.udf2,
            udf3: order.udf3
        };
        
        console.log('=== PAYMENT PARAMS DEBUG ===');
        console.log('Final params being sent:', params);
        console.log('productinfo value:', params.productinfo);
        console.log('firstname value:', params.firstname);
        console.log('email value:', params.email);
        console.log('phone value:', params.phone);
        console.log('===========================');
        
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = order.pg_url;
        
        Object.keys(params).forEach(key => {
            if (params[key] !== undefined && params[key] !== null) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = params[key];
                form.appendChild(input);
            }
        });
        
        document.body.appendChild(form);
        form.submit();
    }

    handlePayment = () => {
        const module = this.getModuleDetails();
       // const { total } = this.calculateTotal();

            let total = this.state.priceDetails.total_amount_with_gst;
        
        if (module.price === 0) {
            this.props.onPaymentSuccess();
            return;
        }

        this.setState({ isLoading: true });
        
        // Set a flag to indicate payment is in progress
        localStorage.setItem('paymentInProgress', 'true');
        
        const baseUrl = window.location.href.split("?")[0];
        const success_redirect = `${baseUrl}?status=success`;
        const failure_redirect = `${baseUrl}?status=failure`;
        
        const signupResponse = sessionStorage.getItem('signupResponse');
        const userData = signupResponse ? JSON.parse(signupResponse) : {};
        
        console.log('=== SIGNUP RESPONSE DEBUG ===');
        console.log('Raw signupResponse:', signupResponse);
        console.log('Parsed userData:', userData);
        console.log('userData.user:', userData.user);
        console.log('============================');
        
        // Handle both direct user data and nested user object
        const user = userData.user || userData;
        
        const reqData = {
            product_ids: [module.id],
            user: {
                id: user.id,
                name: user.name,
                email: user.email,
                mobile: user.phone || user.mobile
            },
            amount: total,
            success_redirect,
            failure_redirect,
            coupon: this.state.couponCode,
            gst_number: this.state.gstNumber
        };

        this.createPackageOrder(reqData)
            .then((response) => {
                this.setState({ isLoading: false });
                
                console.log('=== API RESPONSE DEBUG ===');
                console.log('Full API response:', response);
                console.log('response.order:', response.order);
                console.log('========================');
                
                if (response && response.order && response.order.pg_url) {
                    this.submitPaymentForm(response.order);
                } else {
                    this.props.onPaymentSuccess();
                }
            })
            .catch((err) => {
                this.setState({ isLoading: false });
                localStorage.removeItem('paymentInProgress');
                console.error('Payment API Error:', err);
                alert('Payment initialization failed. Please try again.');
            });
    }

    render() {
        const module = this.getModuleDetails();
        const { basePrice, gst, total } = this.calculateTotal();
        const isFree = module.price === 0;

        if (this.state.loadingPrice) {
            return (
                <div className="reset-pass">
                    <div className="form-min-block-1 text-center">
                        <Loading />
                        <p>Loading price details...</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="reset-pass">
                <div className="form-min-block-1">
                    <h3 className="input-label mb-4">Payment Details</h3>
                    
                    <div className="payment-summary mb-4">
                        <div className="module-details p-3 border rounded">
                            <h5>{module.name}</h5>
                            <div className="price-breakdown">
                                <div className="d-flex justify-content-between">
                                    <span>Base Price:</span>
                                    <span>₹{basePrice}</span>
                                </div>
                                {!isFree && (
                                    <>
                                        {this.state.isCouponApplied && (
                                            <>
                                                <div className="d-flex justify-content-between text-success">
                                                    <span>Discount:</span>
                                                    <span>-₹{this.state.discountAmount.toFixed(2)}</span>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span>Discounted Price:</span>
                                                    <span>₹{(basePrice - this.state.discountAmount).toFixed(2)}</span>
                                                </div>
                                            </>
                                        )}
                                        <div className="d-flex justify-content-between">
                                            <span>GST (18%):</span>
                                            <span>₹{gst.toFixed(2)}</span>
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-between font-weight-bold">
                                            <span>Final Amount:</span>
                                            <span>₹{total.toFixed(2)}</span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {!isFree && (
                        <>
                            <Form.Group className="mb-3">
                                <Form.Label className="input-label">Coupon Code (Optional)</Form.Label>
                                <div style={{ position: 'relative' }}>
                                    <Form.Control 
                                        name="couponCode" 
                                        value={this.state.couponCode} 
                                        type="text" 
                                        placeholder="Enter coupon code" 
                                        onChange={(e) => this.setState({ couponCode: e.target.value })} 
                                        disabled={this.state.isCouponApplied}
                                        style={{ paddingRight: '60px' }}
                                    />
                                    {this.state.couponCode && !this.state.isCouponApplied && (
                                        <span 
                                            onClick={this.verifyCouponCode}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#007bff',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Apply
                                        </span>
                                    )}
                                    {this.state.isCouponApplied && (
                                        <span 
                                            onClick={this.removeCoupon}
                                            style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#dc3545',
                                                cursor: 'pointer',
                                                fontSize: '12px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Remove
                                        </span>
                                    )}
                                </div>
                                {this.state.couponError && (
                                    <div className="text-danger mt-1 small">{this.state.couponError}</div>
                                )}
                                {this.state.couponSuccess && (
                                    <div className="text-success mt-1 small">{this.state.couponSuccess}</div>
                                )}
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="input-label">GST Number (Optional)</Form.Label>
                                <Form.Control 
                                    name="gstNumber" 
                                    value={this.state.gstNumber} 
                                    type="text" 
                                    placeholder="Enter GST number" 
                                    onChange={(e) => this.setState({ gstNumber: e.target.value })} 
                                />
                            </Form.Group>
                        </>
                    )}

                    <Form.Group className="mb-3">
                        <Button 
                            buttonStyle={this.state.isLoading ? "red-btn btn-full-size no-margin loading-btn-disable" : "red-btn btn-full-size no-margin"}
                            onClick={this.handlePayment}
                            disabled={this.state.isLoading}
                        >
                            {this.state.isLoading && <Loading/>}
                            {!this.state.isLoading && (isFree ? 'Continue' : `Pay Now ₹${total.toFixed(2)}`)}
                        </Button>
                    </Form.Group>
                </div>
            </div>
        );
    }

    handleCookie = (token, paymentOrderId) => {
        const { cookies } = this.props;
        if(token){
            cookies.set("userToken", token, COOKIE_OPTIONS);
        }
        if(paymentOrderId){
            cookies.set("paymentOrderId", paymentOrderId, COOKIE_OPTIONS);
        }
        cookies.set('redirectFromWebsite', true, COOKIE_OPTIONS);
        cookies.set('websiteUser', true, COOKIE_OPTIONS);
    }
}

export default withCookies(Payment);